import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Home from './components/Home';
import {
  updateIocList,
  updateIocListFromCache,
  paginationIocList,
  paginationIocListFromCache,
} from '../../redux/actions';
import {
  exportListToCSV,
  exportListToSplunk,
  exportListToSTIX,
  resetStixExportLimitedStatus,
  exportListToSTIXLimited,
  exportListToJSON,
  loadMergeAPIExploreIPDensity,
  resetFilterProfile,
  resetEnrichment,
  setFeedStateFilter,
} from '../../redux/actions/ioc';
import {
  toggleFilterSidebar,
  toggleLeftMenu,
  changeSelectedFilterProfile,
} from '../../redux/actions/filters';
import { selectFilterSettings } from '../../redux/selectors/filters';
import { getFilterProfile } from '../../redux/selectors/ioc';
import {
  loadFilterProfiles,
  loadFilters,
  clearFilterProfile,
} from '../../redux/actions/filters';
import { loadUser } from '../../redux/actions/user';
import { loadAPIVersion } from '../../redux/actions/version';
import { loadMySubscriptionPlan } from '../../redux/actions/user';
import { updateTag } from '../../redux/actions';

import {
  clearScoreDetails,
  loadScoreDetails,
  loadNewScoreDetails,
  toggleFalsePositive,
  toggleTruePositive,
  deleteIOC,
  exportSingleIOC,
} from '../../redux/actions/ioc';

const mapStateToProps = (state) => {
  return {
    filterEnabled: state.ioc.filterEnabled,
    exploreAPIIPDensityDetails: state.ioc.exploreAPIIPDensityDetails,
    pagination: state.ioc.pagination,
    lazyPagination: state.ioc.lazyPagination,
    sorting: state.ioc.sorting,
    iocList: state.ioc.iocList,
    next: state.ioc.next,
    previous: state.ioc.previous,
    filters: state.ioc.filters,
    status: state.ioc.status,
    paginationStatus: state.ioc.paginationStatus,
    detailStatus: state.ioc.detailsStatus,
    newDetailsStatus: state.ioc.newDetailsStatus,
    deleteStatus: state.ioc.deleteStatus,
    ipDensityStatus: state.ioc.ipDensityStatus,
    scoreDetails: state.ioc.scoreDetails,
    newScoreDetails: state.ioc.newScoreDetails,
    total: state.ioc.total,
    sortOrder: state.ioc.sortOrder,
    activeThreatRankingEndpoint: state.ioc.activeThreatRankingEndpoint,
    endpointParams: state.ioc.endpointParams,
    filterSettings: selectFilterSettings(state),
    collapsed: !state.sidebar.advancedFilterMenuOpen,
    leftMenuSideBarVisible: !state.sidebar.leftMenuSideBarVisible,
    advancedFilterMenuOpen: !state.sidebar.advancedFilterMenuOpen,
    filterProfile: getFilterProfile(state),
    selectedProfile: state.filter.selectedProfile,
    availableFilterProfiles: state.filter.profiles,
    feedStateFilterCategory: state.ioc.feedStateFilter,
    mySubscriptionPlan: state.user.mySubscriptionPlan,
    mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
    stixDataStatus: state.ioc.stixDataStatus,
    stixData: state.ioc.stix_data,
    tag: state.ioc.tag,
    threat_ranking_cached_flag: state.ioc.threat_ranking_cached_flag,
  };
};

const mapDispatchToProps = {
  toggleFalsePositive,
  toggleTruePositive,
  clearScoreDetails,
  loadScoreDetails,
  loadNewScoreDetails,
  updateIocList,
  updateIocListFromCache,
  paginationIocList,
  paginationIocListFromCache,
  exportListToCSV,
  loadMergeAPIExploreIPDensity,
  exportListToSplunk,
  exportListToSTIX,
  resetStixExportLimitedStatus,
  exportListToSTIXLimited,
  exportListToJSON,
  toggleFilterSidebar,
  toggleLeftMenu,
  loadFilterProfiles,
  loadFilters,
  loadUser,
  deleteIOC,
  exportSingleIOC,
  loadAPIVersion,
  resetFilterProfile,
  resetEnrichment,
  loadMySubscriptionPlan,
  updateTag,
  changeSelectedFilterProfile,
  clearFilterProfile,
  setFeedStateFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
